<template>
  <div class="Input">
    <span class="label" :style="{ width: labelWidth || '129px' }" v-if="label">{{
      label
    }}</span>
    <div class="input_box">
      <div class="input_boxcross">
        <input
          v-model="col"
          :placeholder="placeholder"
          :type="type"
          v-bind="$attrs"
          :readonly="readonly"
          @input="
            (e) => {
              handleinput(e);
            }
          "
          :disabled="disabled"
          :maxlength="maxlength"
          ref="Field"
        />

        <span class="amountCompany">{{ amountCompany }}</span>
        <!-- <span>元</span> -->
        <van-icon
          v-show="isDelete"
          @click="clickDelete"
          class="cross"
          name="cross"
        />
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import Schema from 'async-validator';

export default {
  name: 'Input',
  props: [
    'props',
    'placeholder',
    'reg',
    'maxlength',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'separate',
    'readonly',
    'toUpperCase',
    'amountCompany',
    'ispayLimit',
  ],
  data() {
    return {
      col: '',
      errorMessage: '',
      isDelete: false,
    };
  },
  watch: {
    readonly: {
      handler(val) {
        // eslint-disable-next-line no-unused-expressions
        !val ? (this.isDelete = false) : '';
      },
      immediate: true,
    },
    // ispayLimit: {
    //   handler(val) {
    //     const payLimit = parseInt(val.payLimit, 10);
    //     const col = parseInt(this.col, 10);
    //     if (col > payLimit) {
    //       this.errorMessage = `申请金额不能大于${val.payLimitText}限额`;
    //     } else {
    //       this.errorMessage = '';
    //     }
    //   },
    // },
    // col: {
    //   handler(newVal, oldVal) {
    //     console.log(123,newVal, oldVal, this.value)
    //     if (oldVal === undefined) {
    //       this.col = this.value;
    //     }
    //     if (newVal !== '') {
    //       // eslint-disable-next-line no-unused-expressions
    //       !this.readonly ? (this.isDelete = true) : '';
    //       if (this.ispayLimit) {
    //         const payLimit = parseInt(this.ispayLimit, 10);
    //         const col = parseInt(this.col, 10);
    //         if (col > payLimit) {
    //           this.errorMessage = `申请金额不能大于${this.ispayLimit}限额`;
    //         } else {
    //           this.errorMessage = '';
    //         }
    //       }
    //     } else {
    //       this.isDelete = false;
    //     }
    //     this.$emit('input', newVal);
    //   },
    //   immediate: true,
    // },
    value: {
      handler(val) {
        this.col = val;
      },
      immediate: true,
    },
  },
  methods: {
    // setSeparate(val) {
    //   if (this.separate) {
    //     let value = val.replace(/\D/g, '').substr(0, 11); // 不允许输入非数字字符，超过11位数字截取前11位
    //     const len = value.length;
    //     if (len > 3 && len < 8) {
    //       value = value.replace(/^(\d{3})/g, '$1 ');
    //     } else if (len >= 8) {
    //       value = value.replace(/^(\d{3})(\d{4})/g, '$1 $2 ');
    //     }
    //     return value;
    //   } if (this.toUpperCase) {
    //     return val.toUpperCase();
    //   }
    //   return val;
    // },
    handleinput(val) {
      // this.col = this.setSeparate(val.target.value);
      
      this.col= this.col.replace(/[^\d]/g,'');
      this.$emit('input', this.col);

      // const test = 'test';
      // if (!this.reg) return;
      // const validator = new Schema({
      //   [test]: this.reg,
      // });
      // let value = this.col;
      // if (this.separate) {
      //   value = value.replace(/\s+/g, '');
      // }
      // validator.validate({ [test]: value }, (errors) => {
      //   if (errors) {
      //     this.errorMessage = errors[0].message;
      //   } else {
      //     this.errorMessage = '';
      //   }
      // });
    },
    clickDelete() {
      this.col = '';
      this.errorMessage = '';
    },
  },
};
</script>
<style scoped>
.Input {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
}
input {
  width: 70%;
  border: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  align-items: center;
}
.error-message {
  color: #ee0a24;
  font-size: 12px;
  text-align: left;
}
.input_box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.input_boxcross > input:disabled {
  color: #495060;
  -webkit-text-fill-color: #495060;
  -webkit-opacity: 1;
  opacity: 1;
}
.cross {
  color: #9e9fa0;
}
input:disabled {
  background-color: #fff !important;
}
.amountCompany {
  font-size: 14px;
  color: #1c2438;
}
</style>
